
const setCustomText = () => {

}

export { setCustomText };
